import React from 'react';
import NavSection from './NavSection';
import { piMenuItems } from './menuItems';

const PINav = ({ isOpen, expandedSections, onToggleSection, onNavClick }) => {
    return (
        <>
            <NavSection
                isOpen={isOpen}
                sectionKey="dashboards"
                sectionLabel="Dashboards"
                sectionSubtext="Overview & analytics"
                menuItems={piMenuItems.dashboard}
                isExpanded={expandedSections.dashboards}
                onToggle={onToggleSection}
                onNavClick={onNavClick}
            />

            <NavSection
                isOpen={isOpen}
                sectionKey="piDoctors"
                sectionLabel="Data Management"
                sectionSubtext="Clinical Consent & Data Capture"
                menuItems={piMenuItems.management}
                isExpanded={expandedSections.piDoctors}
                onToggle={onToggleSection}
                onNavClick={onNavClick}
            />
        </>
    );
};

export default PINav;